import type { CheckedState } from '@latitude/checkbox';
import { Checkbox } from '@latitude/checkbox';
import { FormComponentWrapper } from 'components/FormComponentWrapper';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import type { FormCheckboxProps } from './types';

export const FormCheckbox = <T extends FieldValues>({
  name,
  control,
  description,
  label,
  checkboxLabel,
  wrapperClassname,
  disabled,
  children,
  rules,
  message,
  onCheckedChange,
  ...restProps
}: FormCheckboxProps<T>) => {
  return (
    <Controller
      name={name}
      {...(control
        ? { control }
        : {
            // if undefined, Controller reads from FormProvider
          })}
      rules={rules}
      render={({
        field: { onBlur, onChange, value },
        fieldState: { error },
      }) => {
        const handleOnChange = (checkedState: CheckedState) => {
          onChange(checkedState);
          if (onCheckedChange) {
            onCheckedChange(checkedState === true);
          }
        };
        return (
          <FormComponentWrapper
            name={name}
            description={description}
            label={label}
            error={error}
            className={wrapperClassname}
            disabled={disabled}
            message={message}
          >
            <Checkbox
              {...restProps}
              disabled={disabled}
              invalid={!!error}
              label={checkboxLabel}
              onBlur={onBlur}
              onCheckedChange={handleOnChange}
              checked={!!value}
            >
              {children}
            </Checkbox>
          </FormComponentWrapper>
        );
      }}
    />
  );
};
